import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  HomeOutlined,
  UserOutlined,
  HistoryOutlined,
  LineChartOutlined,
  CalculatorOutlined,
  PhoneOutlined,
  WarningOutlined,
  CalendarOutlined,
  UnorderedListOutlined,
  ReconciliationOutlined,
  ScheduleOutlined,
  BuildOutlined,
  ToolOutlined,
  SnippetsOutlined,
  PullRequestOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import './MenuSider.scss';
import PermissionsAsigner from '../PermissionsAsigner';
import { ROLES } from '../../utils/constants';
import { useSelector } from 'react-redux';
import Spin from '../Spin';

function MenuSider(props) {
  const { menuCollapsed, setMenuCollapsed, location, typeMenu } = props;

  const { Sider } = Layout;
  const { SubMenu } = Menu;

  let menuHosp = (
    <Sider className="admin-sider" collapsed={menuCollapsed}>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[location.pathname]}
      >
        <Menu.Item key="/">
          <Link to={'/'}>
            <HomeOutlined /> <span className="navText">Home</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/works">
          <Link to={'/works'}>
            <BuildOutlined />
            <span className="navText">Obras</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/providers">
          <Link to={'/providers'}>
            <BuildOutlined />
            <span className="navText">Proovedores</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="/configurations">
          <Link to="/configurations">
            <SettingOutlined />
            <span className="navText">Configuración</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/users">
          <Link to="/users">
            <UserOutlined />
            <span className="navText">Usuarios</span>
          </Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
  let menuAmb = (
    <Menu
      theme="dark"
      mode="vertical"
      defaultSelectedKeys={[location.pathname]}
      selectedKeys={[location.pathname]}
      style={{ zIndex: 1 }}
    >
      <Menu.Item key="/">
        <Link to={'/'}>
          <HomeOutlined /> <span className="navText">Home</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/ambulatory">
        <Link to={'/ambulatory'}>
          <ReconciliationOutlined /> <span className="navText">Pacientes</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/turns">
        <Link to={'/turns'}>
          <ScheduleOutlined /> <span className="navText">Mis Turnos</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/protocolo">
        <Link to={'/protocolo'}>
          <WarningOutlined /> <span className="navText">Protocolos</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/phones">
        <Link to={'/phones'}>
          <PhoneOutlined /> <span className="navText">Telefonos Utiles</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/calendar">
        <Link to={'/calendar'}>
          <CalendarOutlined /> <span className="navText">Calendario</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/charts">
        <PermissionsAsigner requiredRole={ROLES.ADMIN} visible={ROLES.VIEW}>
          <Link to={'/charts'}>
            <LineChartOutlined />
            <span className="navText">Estadisticas</span>
          </Link>
        </PermissionsAsigner>
      </Menu.Item>
      <Menu.Item key="/users">
        <PermissionsAsigner requiredRole={ROLES.OWNER}>
          <Link to={'/users'}>
            <UserOutlined /> <span className="navText">Usuarios</span>
          </Link>
        </PermissionsAsigner>
      </Menu.Item>
    </Menu>
  );

  return (
    <Sider
      className="admin-sider"
      collapsed={menuCollapsed}
      breakpoint="lg"
      onBreakpoint={(broken) => {
        setMenuCollapsed(broken);
      }}
    >
      {typeMenu ? menuAmb : menuHosp}
    </Sider>
  );
}

export default withRouter(MenuSider);
